/**
 * Main App component with authentication and routing
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SessionProvider } from './contexts/SessionContext';
import { LoadingProvider } from './contexts/LoadingContext';
import { WorkflowMetadataProvider } from './contexts/WorkflowMetadataContext';
import LoginPage from './components/auth/LoginPage';
import OAuthCallback from './components/auth/OAuthCallback';
import ProtectedRoute from './components/auth/ProtectedRoute';
import MainApp from './App'; // Renamed current App component
import GlobalErrorBoundary from './components/GlobalErrorBoundary';
import PasswordProtection from './components/PasswordProtection';
import LoginDemo from './components/demo/LoginDemo';

function AppWithAuth() {
  // Check if password protection is enabled via env variable
  const isPasswordProtected = process.env.REACT_APP_ENABLE_PASSWORD === 'true';
  
  const appContent = (
    <GlobalErrorBoundary>
      <AuthProvider>
        <SessionProvider>
          <LoadingProvider>
            <WorkflowMetadataProvider>
              <Router>
                <Routes>
                  {/* Public routes */}
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/auth/callback" element={<OAuthCallback />} />
                  <Route path="/demo" element={<LoginDemo />} />
                  
                  {/* Protected routes */}
                  <Route 
                    path="/*" 
                    element={
                      <ProtectedRoute>
                        <MainApp />
                      </ProtectedRoute>
                    } 
                  />
                </Routes>
              </Router>
            </WorkflowMetadataProvider>
          </LoadingProvider>
        </SessionProvider>
      </AuthProvider>
    </GlobalErrorBoundary>
  );

  // Wrap with password protection if enabled
  if (isPasswordProtected) {
    return <PasswordProtection>{appContent}</PasswordProtection>;
  }
  
  return appContent;
}

export default AppWithAuth;
